import { Outlet } from "react-router-dom";
import { Clock, LogOut, Shield } from "lucide-react";
import { useEmployee } from "@/context/EmployeeContext";
import { Button } from "@/components/ui/button";

export const AdminLayout = () => {
  const { employee, logout } = useEmployee();

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-slate-200 bg-white sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-purple-600 rounded-xl flex items-center justify-center">
              <Shield className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-slate-900 tracking-tight font-['Manrope']">
                ZeitFlow
              </h1>
              <span className="text-xs text-purple-600 font-medium">Admin</span>
            </div>
          </div>
          
          {/* User Menu */}
          <div className="flex items-center gap-4">
            <span className="text-sm text-slate-600">{employee?.name}</span>
            <Button
              variant="outline"
              size="sm"
              onClick={logout}
              className="gap-2"
              data-testid="admin-logout"
            >
              <LogOut className="w-4 h-4" />
              Abmelden
            </Button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
